import L from 'leaflet'
import { map as mapEndpoints } from '@/api/api-endpoints'
import markerIcon from '../../../assets/images/icons/map-icon.svg'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'
import { COLORS } from '@/utils'

export default {
  data() {
    return {
      msnDetailLayer: null,
    }
  },
  watch: {
    $route: 'onRoute',
    msnDetailsOn: function (value) {
      if (!value) return
      this.getMsnDetail(value)
    },
  },
  computed: {
    msnDetailsOn() {
      return this.$store.getters.msnDetailsOn
    },
  },
  methods: {
    onRoute(newValue) {
      if (!newValue.query.layers) {
        return newValue.query.layers
      }
    },
    async getMsnDetail(id) {
      if (this.msnDetailLayer) {
        this.map.removeLayer(this.msnDetailLayer)
      }
      const year = this.year
      const response = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: mapEndpoints.msnDetail({
            query: { id, year },
          }),
        })
      ).data[0]

      const garbageSources = response?.garbage_sources || []
      const coords = [[response?.latitude, response?.longitude]]
      this.msnDetailLayer = L.layerGroup()

      if (!garbageSources) return

      garbageSources.forEach((item) => {
        if (!item.latitude && !item.longitude) return
        coords.push([item.latitude, item.longitude])
        const icon = L.icon({
          iconUrl: markerIcon,
          shadowUrl: iconShadow,
          iconSize: [25, 41],
          iconAnchor: [13, 20],
        })
        const iconLayer = L.marker([item.latitude, item.longitude], {
          icon: icon,
        })
        iconLayer.bindTooltip(item.name)

        iconLayer.addTo(this.msnDetailLayer)
      })

      if (!coords) return
      coords.forEach((item, index) => {
        L.polyline([coords[0], coords[index]], { color: COLORS.grey }).addTo(
          this.msnDetailLayer
        )
      })
      this.msnDetailLayer.addTo(this.map)
    },
  },
}
